function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import useAsset from './useAsset';
export var useProjectStatusColors = function() {
    var asset = useAsset();
    var _obj, _obj1;
    return {
        OneTime: (_obj = {}, _define_property(_obj, asset.constants.STATUS_DRAFT, 'gray.300'), _define_property(_obj, asset.constants.STATUS_ACTIVE, 'green.400'), _define_property(_obj, asset.constants.STATUS_PAUSED, 'warning.500'), _define_property(_obj, asset.constants.STATUS_COMPLETE, 'teal.500'), _define_property(_obj, asset.constants.STATUS_ARCHIVED, 'gray.500'), _obj),
        Recurring: (_obj1 = {}, _define_property(_obj1, asset.constants.PROJECT_SCHEDULE_STATUS_DRAFT, 'gray.300'), _define_property(_obj1, asset.constants.PROJECT_SCHEDULE_STATUS_ACTIVE, 'green.400'), _define_property(_obj1, asset.constants.PROJECT_SCHEDULE_STATUS_PAUSED, 'warning.500'), _define_property(_obj1, asset.constants.PROJECT_SCHEDULE_STATUS_COMPLETE, 'teal.500'), _define_property(_obj1, asset.constants.PROJECT_SCHEDULE_STATUS_ARCHIVED, 'gray.500'), _obj1)
    };
};
